__turbopack_context__.v({
  "appLinks": "ruobuq_appLinks",
  "content": "ruobuq_content",
  "description": "ruobuq_description",
  "downloadBadge": "ruobuq_downloadBadge",
});
